import React from "react";
import { Link } from "react-router-dom";
import { Smartphone } from "lucide-react";
import { isStandalone } from "../../hooks/useInstallPrompt";
import { trackAppTap } from "../../lib/appStats";

// "Get the app" pill; hidden inside the installed app.
export const GetAppButton = ({ testid = "get-app-btn", source = "footer", onClick, className = "" }) => {
  if (isStandalone()) return null;
  return (
    <Link to="/get-app" onClick={() => { trackAppTap(source); onClick?.(); }} data-testid={testid}
      className={`group inline-flex items-center gap-2 h-10 pl-3 pr-4 rounded-full bg-slate-900 text-white text-sm font-semibold hover:bg-slate-700 transition-colors ${className}`}>
      <Smartphone size={16} className="transition-transform duration-200 group-hover:-rotate-12" />
      Get the app
      <span className="text-[11px] font-normal text-slate-300">Android &amp; iPhone</span>
    </Link>
  );
};

export default GetAppButton;
